import { render, staticRenderFns } from "./ProductAttributesFactoring.vue?vue&type=template&id=35469230&scoped=true&lang=pug&"
import script from "./ProductAttributesFactoring.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesFactoring.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributesFactoring.vue?vue&type=style&index=0&id=35469230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35469230",
  null
  
)

/* custom blocks */
import block0 from "./ProductAttributesFactoring.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports